import { RoutesObjectInterface } from "../router.types";
import SalesWorkspace from '@/features/Sale/SalesWorkspace';

const privateRoutes: RoutesObjectInterface[] = [
  {
    path: '/SalePlan/*',
    element: <SalesWorkspace/>
  }
]

export default privateRoutes;
